/* tslint:disable */
/* eslint-disable */
/**
 * RAISE Events API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DetailMessage
 */
export interface DetailMessage {
    /**
     * 
     * @type {string}
     * @memberof DetailMessage
     */
    detail: string;
}

/**
 * Check if a given object implements the DetailMessage interface.
 */
export function instanceOfDetailMessage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "detail" in value;

    return isInstance;
}

export function DetailMessageFromJSON(json: any): DetailMessage {
    return DetailMessageFromJSONTyped(json, false);
}

export function DetailMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetailMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detail': json['detail'],
    };
}

export function DetailMessageToJSON(value?: DetailMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail': value.detail,
    };
}

